// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__29bft","colCheckbox":"styles_colCheckbox__3_e8g"};